import {DocumentService} from "./DocumentService";
import {CreateIncomingBankPaymentDto} from "../../components/Pages/Documents/IncomingBanks/dtos/CreateIncomingBankPaymentDto";
import { AppEntities } from "../../config/entities";
import { IncomingBankPaymentDto } from "src/components/Pages/Documents/IncomingBanks/dtos/IncomingBankPaymentDto";

export class IncomingBankPaymentService extends DocumentService {
    async Clone(id: string) {
        const newObject: IncomingBankPaymentDto = await this.Get(id);
        const clonedObject: CreateIncomingBankPaymentDto = {...newObject, documentNumber: undefined, documentDate: new Date()};
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
    async createBasedAtOrder(id:string){
        const orderDto = await AppEntities.SalesOrders.getDataService().Get(id);
        const newCustomerInvoice:IncomingBankPaymentDto = {...orderDto};
        
        
        
        return newCustomerInvoice;
    };
}